import DataTableCommon from './containers/dataTableCommon'

export {default as DataTableCommonLayout} from './components/dataTableCommonLayout'

export default DataTableCommon
